<p-dialog [(visible)]="closeConfirmationModalVisible" [style]="{width: '35vw'}" [modal]="true" (onHide)="reloadHardCopyDetail()" >
    <ng-template pTemplate="header">
       <b> Complete Hardcopy Activity</b>
    </ng-template>
    <p>You hereby confirm that the task has been performed according to applicable local procedures. 
        This action is not reversible, do you want to proceed?</p>
    <div *ngIf="removeActivity">
        <div class="field">
            <bpt-numeric-input  label="RemovedCopies" [showButtons]="true" 
                 id="removedCopies" (numericInputKeyUp)="onCopiesChanges($event)"
                 [maxValue]="maxValueLimit" [minValue]="1"
                [allowKeyboardIncrement]="true" placeholder="RemovedCopies" [(ngModel)]="removedCopiesMax" >
            </bpt-numeric-input>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button appPreventDoubleClick label="Confirm" type="submit" id="confirmButton" (debounceClick)="confirmClick($event)" class="align-right" >
        </p-button>
        <p-button appPreventDoubleClick label="Cancel" styleClass="p-button-outlined" type="submit" id="confirmationCancelButton" (debounceClick)="cancelClick()" class="align-right" >
        </p-button>
    </ng-template>
</p-dialog>
